/* eslint-disable */
import React, { PureComponent, cloneElement } from 'react';
import PropTypes from 'prop-types';
import { autobind } from 'core-decorators';
import CSSModules from 'react-css-modules';
import classNames from 'classnames';
import ClickableElement from '../ClickableElement';
import Icon from '../Icon';
import { COLORS } from '../../constants/styles';
import styles from './index.styl';

@CSSModules(styles, { allowMultiple: true })
export default class ExpandableBlock extends PureComponent {
  static propTypes = {
    className: PropTypes.string,
    content: PropTypes.shape({
      head: PropTypes.oneOfType([
        PropTypes.element,
        PropTypes.node,
        PropTypes.number,
        PropTypes.string,
      ]).isRequired,
      body: PropTypes.oneOfType([
        PropTypes.element,
        PropTypes.node,
        PropTypes.number,
        PropTypes.string,
      ]),
    }),
    icon: PropTypes.string,
    opened: PropTypes.bool,
    locked: PropTypes.bool,
    large: PropTypes.bool,
    hasCustomMarker: PropTypes.bool,
    headStyle: PropTypes.object,
  };

  static defaultProps = {
    opened: true,
  };

  state = {
    opened: true,
  };

  componentWillMount() {
    this.setState({ opened: this.props.opened });
  }

  @autobind
  toggle(e) {
    e.stopPropagation();
    if (!this.props.locked) {
      this.setState({ opened: !this.state.opened });
    }
  }

  render() {
    const {
      className,
      content,
      icon,
      locked,
      large,
      headStyle,
      hasCustomMarker,
    } = this.props;

    const customMarker = !locked && (
      <div styleName="marker" className="o-50 pa3" onClick={this.toggle}>
        <If condition={icon}>
          <Icon
            name={icon}
            style={{
              transform: 'rotate(180deg)',
              stroke: COLORS.bluePrimary,
            }}
          />
        </If>
      </div>
    );

    const clickableElements = locked
      ? [content.head]
      : [content.head, customMarker];

    return (
      <div styleName="root" {...{ className }}>
        <ClickableElement
          children={clickableElements.map((item, i) => cloneElement(item, {key: i}))}
          onClick={!hasCustomMarker ? this.toggle : null}
          styleName={classNames(
            'head',
            { 'head--closed': !this.state.opened },
            { 'head--default': !icon },
            { 'head--locked': locked },
            { 'head--large': large },
          )}
          style={headStyle}
        />
        <div className={classNames({ dn: !this.state.opened })}>
          {content.body}
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/ExpandableBlock/index.jsx